import React from 'react';
import {Dropdown, Input, Layout, Menu} from 'antd';
import './index.style.less';
import {FiMoreVertical} from 'react-icons/fi';
import AppLogo from '../components/AppLogo';

import AppNotifications from '../../AppNotifications';
import {AiOutlineMenu} from 'react-icons/ai';
import PropTypes from 'prop-types';
import AppHorizontalNav from '../components/AppHorizontalNav';
import UserInfo from '../components/UserInfo';
import {useSidebarContext} from '../../../../contexts/AppContextProvider/SidebarContextProvider';
import {useTranslation} from 'react-i18next';

const AppHeader = ({showDrawer}) => {
  const {Header} = Layout;
  const {Search} = Input;

  const {t} = useTranslation();

  const {sidebarColorSet} = useSidebarContext();

  const menuMobile = (
    <Menu>
      <AppNotifications />
    </Menu>
  );

  return (
    <Header
      className='app-header-hor-header-fixed'
      style={{
        backgroundColor: sidebarColorSet.sidebarBgColor,
        color: sidebarColorSet.sidebarTextColor,
      }}>
      <div className='header-hor-header-fixed-main'>
        <div className='container'>
          <div className='header-hor-header-fixed-main-flex'>
            <a className='trigger' onClick={showDrawer}>
              <AiOutlineMenu />
            </a>
            <AppLogo hasSidebarColor />
            <AppHorizontalNav className='app-main-hor-header-fixed-menu' />
            <Search
              className='header-search-hor-header-fixed'
              placeholder={t('int-enter-search-text')}
            />

            <div className='app-header-hor-header-fixed-sectionDesktop'>
              <AppNotifications />
            </div>
            <UserInfo />
            <div className='app-header-hor-header-fixed-section-mobile'>
              <Dropdown overlay={menuMobile} trigger={['click']}>
                <a
                  className='ant-dropdown-link'
                  onClick={(e) => e.preventDefault()}>
                  <FiMoreVertical />
                </a>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </Header>
  );
};

export default AppHeader;

AppHeader.propTypes = {
  showDrawer: PropTypes.func,
};
